import { render, staticRenderFns } from "./HouseAd_RewardType.vue?vue&type=template&id=fd0580bc&"
import script from "./HouseAd_RewardType.vue?vue&type=script&lang=js&"
export * from "./HouseAd_RewardType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports